import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  hover?: boolean;
}

export default function Card({ 
  children, 
  className = '', 
  padding = 'md',
  hover = false 
}: CardProps) {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  const hoverClass = hover ? 'hover:shadow-xl hover:scale-105 transition-all duration-300' : '';

  return (
    <div className={`bg-gray-800 rounded-xl shadow-lg border border-gray-700 ${paddingClasses[padding]} ${hoverClass} ${className}`}>
      {children}
    </div>
  );
}